import Vue from 'vue';

export default {
  // 发票列表
  getInvoiceList(params) {
    return Vue.axios.post('/api/v1.0/chanquan/invoice/selectProjectInvoiceList', params);
  },
  // 获取开票信息
  getInvoiceInfo(bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/invoice/toApplyInvoice/' + bidId);
  },
  sendInfo(params) {
    return Vue.axios.post('/api/v1.0/chanquan/invoice/applyInvoice', params);
  },
  getDetail(projectId, bidId, projectType) {
    return Vue.axios.get('/api/v1.0/chanquan/invoice/invoiceDetails/' + projectId + '/' + bidId + '/' + projectType);
  }
};
